import { useQueryClient } from '@tanstack/react-query'
import { useCallback } from 'react'
import { meetingListApiV1CollaborationAppMeetingGetQueryKey } from '../gen/base'

export const useInvalidateCollaborationAppMeetingQuery = () => {
    const queryClient = useQueryClient()

    return useCallback(() => {
        queryClient.invalidateQueries({
            predicate: (query) =>
                query.queryKey.some(
                    (key) =>
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        //@ts-expect-error
                        key?.url === meetingListApiV1CollaborationAppMeetingGetQueryKey()[0].url,
                ),
        })
    }, [queryClient])
}
